import React, { Component, createContext } from 'react';
import classNames from 'classnames';
import { FormContext } from '@anwb/form';
import { FormContainerFieldContainer, FormContainerFieldError, FormContainerFieldFormText, FormContainerFieldLabel, FormContainerFieldWrapper, } from './styles/form-container-field.styled';
export const FormContainerFieldContext = createContext({
    handlerValidationMessage: () => { },
});
class FormContainerField extends Component {
    constructor() {
        super(...arguments);
        this.state = {
            textValidityMessage: '',
        };
        this.handlerValidationMessage = (message) => {
            if (message !== this.state.textValidityMessage) {
                this.setState({ textValidityMessage: message });
            }
        };
    }
    render() {
        const { className, size, reference, label, required, textInfo, tooltip, class: reactClassName, sideComponent, children, dataTest = 'form-container-field', colorContext = 'on-light', color = 'default', disabled, } = this.props;
        const containerClassName = classNames('PONCHO-form__field', size && `PONCHO-form__field--${size}`, className || reactClassName);
        const wrapperClassName = classNames('PONCHO-form__field-wrapper', size && `PONCHO-form__field-wrapper--${size}`);
        return (React.createElement(FormContext.Consumer, null, ({ horizontal }) => (React.createElement(FormContainerFieldContext.Provider, { value: {
                handlerValidationMessage: this.handlerValidationMessage,
            } },
            React.createElement(FormContainerFieldContainer, { className: containerClassName, "data-size": size, "data-test": dataTest },
                label && (React.createElement(FormContainerFieldLabel, { htmlFor: reference, id: `${reference || ''}-label`, "$colorContext": colorContext, "$disabled": disabled },
                    label,
                    !required && !horizontal && ' (optioneel)',
                    tooltip)),
                React.createElement(FormContainerFieldWrapper, { className: wrapperClassName, "$size": size },
                    children,
                    sideComponent),
                textInfo && (React.createElement(FormContainerFieldFormText, { className: "PONCHO-form__text", "$colorContext": colorContext, "$color": color, "$disabled": disabled }, textInfo)),
                this.state.textValidityMessage && (React.createElement(FormContainerFieldError, { "aria-live": "assertive", id: `${reference || ''}-error-area`, className: "PONCHO-form__message", "$colorContext": colorContext, "$disabled": disabled }, this.state.textValidityMessage)))))));
    }
}
FormContainerField.defaultProps = {
    size: '',
    required: false,
    label: '',
    reference: 'form-container-field',
    textInfo: '',
    class: '',
    sideComponent: '',
};
export default FormContainerField;
//# sourceMappingURL=FormContainerField.js.map